// Machine Spokesmen Metadata
import MachineSpokesMenSVG from '../../../assets/images/Thoughts/MachineSpokesmen.svg';

const MachineSpokesMenMetadata = {
  id: 'MachineSpokesmen',
  title: 'Machine Spokesmen',
  description: "Where's your personality?",
  thumbnail: MachineSpokesMenSVG,
  featured: false,
};

export default MachineSpokesMenMetadata;
